import { cn } from '@/utilities/ui'
import { cva, type VariantProps } from 'class-variance-authority'
import * as React from 'react'

const variants = cva(
  ['font-body', 'font-weight-body', 'leading-body', 'tracking-body', 'text-pretty'],
  {
    defaultVariants: {
      size: 'lg',
    },
    variants: {
      size: {
        xl: 'text-body-xl',
        lg: 'text-body-lg',
        sm: 'text-body-sm',
        xs: 'text-body-xs',
      },
    },
  },
)

const Text: React.FC<
  {
    ref?: React.Ref<HTMLSpanElement>
  } & React.HTMLAttributes<HTMLSpanElement> &
    VariantProps<typeof variants>
> = ({ size, className, ref, ...props }) => {
  return <span className={cn(variants({ size, className }))} ref={ref} {...props} />
}

export { Text }
